import { useLanguage } from "@/contexts/LanguageContext";
import { UpdateBannerShell } from "./UpdateBannerShell";

/**
 * Bandeau de l'interrupteur d'urgence (release-policy.json). Volontairement
 * SANS bouton de fermeture et SANS recharge forcée : la personne termine son
 * geste en cours, puis actualise.
 */
export function UrgentUpdateBanner() {
  const { t } = useLanguage();
  return (
    <UpdateBannerShell
      message={t("appUpdate.urgentMessage")}
      actionLabel={t("appUpdate.reload")}
      onAction={() => window.location.reload()}
      spacerTestId="urgent-update-spacer"
    />
  );
}
